/* eslint-disable react/jsx-pascal-case */
import { ZonaUrtoEnum, ZoneUrtoType } from "../../types/communication/communicationDataType";
import { noob } from "../../utils/utils-test";
import { Trct_BtnZoneSelector, Trct_UrtoTableCell } from "../styled/ZonaUrto_Trct.style"
import versusImg from './../../assets/svg/versus.svg'
import versusSelectedImg from './../../assets/svg/versus_selected.svg'
import versusMainImg from './../../assets/svg/versus_main.svg'

interface Trtc_UrtoTableCellCmpProps {
    zoneItem: ZoneUrtoType
    addZone: () => void
    removeZone: (zoneItem: ZoneUrtoType) => void
    position?: ZonaUrtoEnum
    excludePositions: ZonaUrtoEnum[]
    isMainImpactPoint?: boolean,
    mainImpactPoint?: ZonaUrtoEnum
}

/* istanbul ignore next */
const Trtc_UrtoTableCellCmp = (props: Trtc_UrtoTableCellCmpProps) => {
    const { zoneItem, addZone, removeZone, position, excludePositions, isMainImpactPoint, mainImpactPoint } = props;

    const isSelected = !!zoneItem.isSelected

    const cellClickHandler = () => {
        if (isDisabled) return;
        if (isSelected) {
            removeZone(zoneItem)
        } else {
            addZone()
        }
    }

    const isExcluded = position && excludePositions?.indexOf(position) >= 0
    const isDisabled = !isMainImpactPoint && position === mainImpactPoint

    return (<>
        {!isExcluded ? <Trct_UrtoTableCell
            disabled={isDisabled}
            isSelected={isSelected}
            onClick={cellClickHandler}
            className={position}>
            <Trct_BtnZoneSelector
                disabled={isDisabled}
                isMainImpactPoint={isMainImpactPoint}
                isSelected={isSelected}
                className={position}
            >
                {!isMainImpactPoint ?
                    <img
                        src={isSelected || isDisabled ? (position === mainImpactPoint ? versusMainImg : versusSelectedImg) : versusImg}
                        alt="zona urto icona selettore" />
                    :
                    <img
                        src={isSelected || isDisabled ? versusMainImg : versusImg}
                        alt="zona urto icona selettore" />
                }
            </Trct_BtnZoneSelector>
        </Trct_UrtoTableCell> :
            <Trct_UrtoTableCell
                onClick={noob}
                className={`${position} excluded-position`} />
        }
    </>
    )
}

export default Trtc_UrtoTableCellCmp